(function () {
    'use strict';

    var app = angular.module('app');

    app.filter('indexTextColor', function () {
        var colors = [
            'txt-color-magenta',
            'txt-color-orange',
            'txt-color-green',
            'txt-color-redLight',
            'txt-color-blueDark',
            'txt-color-pink',
            'txt-color-blue',
            'txt-color-greenDark',
        ]

        return function (index) {
            if(index < colors.length)
                return colors[index];

            return 'txt-default';
        };
    });
})();